import { render, staticRenderFns } from "./V11PotensiPemanfaatan.vue?vue&type=template&id=3c8c7f5a&"
import script from "./V11PotensiPemanfaatan.vue?vue&type=script&lang=js&"
export * from "./V11PotensiPemanfaatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports